import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ClotureButton from './ClotureButton';

class ClotureButtonContainer extends React.Component {
    render() {
        const { isCloture, canCloture, onClick } = this.props;

        return (
            <ClotureButton
                onClick={onClick}
                isCloture={isCloture}
                canCloture={canCloture}
            />
        );
    }
}

const mapStateToProps = state => ({
    isCloture: state.reclamation.reclamations.isCloture
});

ClotureButtonContainer.propTypes = {
    onClick: PropTypes.func.isRequired,
    canCloture: PropTypes.bool.isRequired
};

export default connect(mapStateToProps, null)(ClotureButtonContainer);